<template>
  <div class="select-consultant-widget">
    <!-- company-profile display -->
    <div class="company-profile-container" v-show="consultant_list == true" v-animate-css="'fadeIn'">
      <div class="company-profile-body">
        <div class="search-add-btn-widget">
          <div class="search-widget">
            <img src="@/assets/icons/search.svg" alt />
            <input v-model="search_member_input" @keyup="searchCompanyMember()" type="text"
              placeholder="Type in to Search…" />
          </div>
          <button class="add-btn" @click="addMember()">
            Add New Member
            <img src="@/assets/icons/cicle-add-white-icon.svg" alt />
          </button>
        </div>
        <ul class="consultants-items" v-if="user.consultants.length > 0">
          <li class="consultants-starter">
            <h4>
              <span v-if="selected_count > 0">Selected({{ selected_count | validate }})</span>
              <span v-else>Select</span>
            </h4>
            <div class="consultants-item-header">
              <label>Select all</label>
              <input type="checkbox" v-model="select_all" class="select-checkbox" />
            </div>
          </li>
          <li class="consultants-item" v-for="(item, index) in user.consultants" :key="index">
            <panel-expand>
              <template v-slot:header="{ options }">
                <div class="consultants-item-header">
                  <div class="consultants-item-brand">
                    <img v-if="item.profile_picture" :src="$fullUrl('images/profiles/' + item.profile_picture)" alt />
                    <img v-else src="@/assets/icons/logo_avatar.svg" alt />
                  </div>
                  <div class="content">
                    <div class="title-row">
                      <label>{{ item.first_name | validate }}
                        {{ item.last_name | validate }}</label>
                      <span v-if="item.profile">{{
                        item.profile.address | validate
                      }}</span>
                    </div>
                    <div class="option">
                      <input v-model="item.checked" @change="onUserCheck(item)" type="checkbox" class="select-checkbox" />
                    </div>
                  </div>
                </div>
              </template>
            </panel-expand>
          </li>
        </ul>
        <div class="empty-widget" v-else>
          <div class="empty-widgetheader">
            <label>Consultants</label>
          </div>
          <div class="empty-widget-body">
            <p>
              You have not yet added consultants,
              <br />Click below to add one
            </p>
            <button class="add-btn" @click="addMember()">Add a member</button>
          </div>
        </div>
        <div class="options">
          <consultfied-button v-if="selected_count > 0" :loading="assign_loading" @click="assignConsultants()"
            class="assign-btn">Save</consultfied-button>

          <button class="close-btn" @click="closeModal()">Cancel</button>
        </div>
      </div>
    </div>
    <!-- End -->

    <!-- Member management -->
    <div class="member-management" v-show="member_management_modal == true">
      <div class="member-container" v-if="!request_sent">
        <div class="member-header">
          <h3>Search for consultants to manage</h3>
        </div>
        <div class="member-search-widget">
          <div class="search-container">
            <img src="@/assets/icons/search.svg" alt />
            <input type="text" placeholder="Type in to Search…" v-model="search_consultant_member" />
          </div>
          <div v-show="
            getSearchedPeople &&
            getSearchedPeople.length &&
            search_consultant_member
          " class="search_dropdown__body">
            <div class="dropdown__item" v-for="(person, i) in getSearchedPeople" :key="i" @click="addMate(person)">
              <img v-if="person.profile_picture" :src="$fullUrl('images/profiles/' + person.profile_picture)"
                alt="picture" />
              <img v-else src="@/assets/avatar.png" alt />
              <div class="text">
                <span>{{
                  (person.first_name + " " + person.last_name) | validate
                }}</span>
              </div>
            </div>
          </div>
          <span>Or</span>
          <div class="invite-option">
            <button class="invite-btn">Invite via Email</button>
          </div>
        </div>
        <div class="member-body" v-if="added_member_list.length > 0">
          <label class="member-body-title">The manager is paying monthly 1 USD For every consultants selected
            to manage.</label>
          <div class="member-fieldset">
            <div class="collaboraters-widget">
              <div class="item" v-for="(item, i) in added_member_list" :key="i">
                <img v-if="item.picture" :src="$fullUrl('images/profiles/' + item.picture)" alt="picture"
                  class="profile-img" />
                <img v-else src="@/assets/avatar.png" alt class="profile-img" />
                <span class="name">{{ item.names | validate }}</span>
                <button class="remove-member-btn" @click="removeMate(i)">
                  <img src="@/assets/icons/close.svg" />
                </button>
              </div>
            </div>
          </div>
          <label class="sectected-member-count">{{ added_member_list.length | validate }} Consultants
            selected</label>
        </div>
        <div class="member-body" v-else>
          <label class="member-body-title">No consultants selected to manage.</label>
        </div>
        <div class="member-managment-option">
          <consultfied-button v-if="added_member_list.length > 0" @click="addConsultants()" class="btn-save"
            :loading="company_add_member_loading">Save</consultfied-button>

          <button class="btn-back" @click="showConsultants()">Back</button>
        </div>
      </div>
      <div v-else class="member-container">
        <div>
          Request was sent, Wait until selected
          {{ added_member_list.length > 1 ? "members" : "member" }} approves
          your request.
        </div>
        <div class="member-managment-option">
          <button class="btn-back" @click="showConsultants()">Back</button>
        </div>
      </div>
    </div>
    <!-- End Member management -->
  </div>
</template>

<script>
import panelExpand from "@/components/Partials/panelExpand";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
export default {
  name: "consultants",
  components: {
    panelExpand,
    consultfiedButton,
  },
  props: ["value"],
  data: () => {
    return {
      request_sent: false,
      member_management_modal: false,
      consultant_list: true,
      tab: "all",
      manage_consultant_component: false,
      search_consultant_member: "",
      added_member_list: [],
      company_add_member_loading: false,
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
        consultants: [],
      },
      search_member_input: "",
      selected_id: null,
      select_all: false,
      form_field: {
        id: null,
        company_name: "",
        assignment_role: "",
        client_company: "",
        members: [],
      },
      selected_count: 0,
      assign_loading: false,
    };
  },
  mounted() {
    let vm = this;
    vm.getAllStartData();
  },
  computed: {
    ...mapGetters(["getSearchedPeople"]),
  },
  watch: {
    select_all: function (new_val) {
      let vm = this;
      if (new_val) {
        vm.user.consultants.forEach((item) => {
          eventBus.$set(item, "checked", true);
        });
      } else {
        vm.user.consultants.forEach((item) => {
          eventBus.$set(item, "checked", false);
        });
      }
      vm.selected_count = vm.user.consultants.filter(
        (item) => item.checked
      ).length;
    },
    search_consultant_member: function (query) {
      this.searchPeople(query);
    },
  },
  methods: {
    onUserCheck(item) {
      let vm = this;

      vm.selected_count = vm.user.consultants.filter(
        (item) => item.checked
      ).length;
    },
    assignConsultants() {
      let vm = this;
      let id = vm.value.id;
      vm.form_field.id = id;
      vm.form_field.company_name = vm.user.company_info.company_name;
      vm.form_field.assignment_role = vm.value.roles;
      vm.form_field.client_company = vm.value.customer;
      vm.user.consultants.forEach((item) => {
        if (item.checked) {
          vm.form_field.members.push(item.id);
        }
      });
      vm.assign_loading = true;
      if (vm.form_field.members.length > 0) {
        vm.$store
          .dispatch("COMPANY_ASSING_ASSINGMENT", vm.form_field)
          .then((responce) => {
            vm.assign_loading = false;
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Your assingment invite was now sent",
              type: "success",
              duration: 3000,
            });
            vm.$emit("onClose", null);
          })
          .catch((error) => {
            vm.assign_loading = false;
            vm.$notify({
              group: "status",
              title: "Error message",
              text: "Error while assigning assignment",
              type: "warn",
              duration: 3000,
            });
            console.log(error);
          });
      } else {
        vm.$notify({
          group: "status",
          title: "Error message",
          text: "No consultant selected",
          type: "warn",
          duration: 3000,
        });
        vm.assign_loading = false;
      }
    },
    closeModal() {
      let vm = this;
      vm.$emit("onClose", null);
    },
    searchCompanyMember() {
      let vm = this;
      let query = vm.search_member_input;
      if (vm.search_member_input) {
        vm.$store
          .dispatch("SEARCH_FOR_COMPANY_MEMBERS", { query: query })
          .then((responce) => {
            let consultant_data = vm.processSkills(responce.data);
            console.log(consultant_data);
            eventBus.$set(vm.user, "consultants", consultant_data);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        vm.getAllStartData();
      }
    },
    getAllStartData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ME_USER_COMPANY")
        .then((responce) => {
          vm.user = responce.data;
          let consultant_data = vm.processSkills(vm.user.consultants);
          eventBus.$set(vm.user, "consultants", consultant_data);
        })
        .catch((error) => { });
    },
    removeConsultant(user_id) {
      let vm = this;
      vm.$store
        .dispatch("REMOVE_MEMBER_FROM_COMPANY", {
          company_id: vm.user.company_info.id,
          user_id: user_id,
        })
        .then((responce) => {
          vm.getAllStartData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    processSkills(consultants) {
      return consultants.map((item) => {
        let skills = {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        };
        eventBus.$set(item, "checked", false);
        if (item.skills.length && item.skills.length > 0) {
          item.skills.forEach((skill) => {
            skill.tools.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.tools.push(obj);
            });
            skill.domains.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.domains.push(obj);
            });
            skill.competences.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.competences.push(obj);
            });
            skill.roles.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.roles.push(obj);
            });
            skill.languages.forEach((item) => {
              if (item.lang) {
                let obj = {
                  lang: { name: item.lang.name },
                  level: parseInt(item.level),
                };
                skills.languages.push(obj);
              }
            });
          });
        }
        eventBus.$set(item, "skills", skills);
        return item;
      });
    },
    addConsultants() {
      let vm = this;
      vm.company_add_member_loading = true;
      vm.request_sent = false;
      let data = vm.added_member_list.map((item) => {
        return item.id;
      });
      vm.$store
        .dispatch("ADD_COMPANY_MEMBER", { members: data })
        .then((responce) => {
          vm.company_add_member_loading = false;
          vm.request_sent = true;
        })
        .catch((error) => {
          vm.company_add_member_loading = false;
        });
    },
    removeMate(i) {
      let vm = this;
      vm.added_member_list.splice(i, 1);
    },
    addMate(member) {
      let vm = this;
      let obj = {
        id: member.id,
        names: member.first_name + " " + member.last_name,
        picture: member.profile_picture,
      };
      vm.added_member_list.push(obj);
      vm.search_consultant_member = "";
    },
    searchPeople(query) {
      this.$store.dispatch("SEARCH_FOR_PROJECT_MEMBERS", { query: query });
    },
    onCloseManageConsultant() {
      let vm = this;
      vm.selected_id = null;
      vm.manage_consultant_component = false;
      vm.member_management_modal = false;
      vm.consultant_list = true;
      vm.getAllStartData();
    },
    manageConsultant(id) {
      let vm = this;
      vm.selected_id = id;
      vm.manage_consultant_component = true;
      vm.member_management_modal = false;
      vm.consultant_list = false;
    },
    addMember() {
      let vm = this;
      vm.member_management_modal = true;
      vm.consultant_list = false;
      vm.manage_consultant_component = false;
    },
    showConsultants() {
      let vm = this;
      vm.member_management_modal = false;
      vm.consultant_list = true;
      vm.manage_consultant_component = false;
      vm.request_sent = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.select-consultant-widget {
  padding-top: 50px;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.4);
  display: block;
  z-index: 999;

  @media (min-width: 300px) and (max-width: 630px) {
    padding-top: 53px;
  }

  .company-profile-container {
    margin: 0 auto;
    padding: 1px;
    width: 500px;
    border-radius: 5px;
    background: #f6f6f6;
    margin-bottom: 20px;

    @media (min-width: 300px) and (max-width: 630px) {
      width: 100%;
      margin-bottom: 53px;
    }

    .company-profile-body {
      display: flex;
      flex-direction: column;
      height: 100%;

      .search-add-btn-widget {
        padding: 0px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 75px;

        .search-widget {
          border: 1px solid #ccc;
          height: 45px;
          width: 50%;
          display: flex;
          align-items: center;
          padding: 0px 10px;
          border-radius: 5px;

          img {
            width: 25px;
            height: 25px;
          }

          input {
            height: 43px;
            width: 100%;
            padding-left: 15px;
            outline: none;
            border: none;
            background: #f6f6f6;
          }
        }

        .reflesh-btn {
          width: 100px;
          height: 45px;
          background: transparent;
          border-radius: 5px;
          opacity: 1;
          color: #1885ad;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #1885ad;
        }

        .add-btn {
          width: 191px;
          height: 45px;
          background: #1885ad 0% 0% no-repeat padding-box;
          border-radius: 5px;
          opacity: 1;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            margin-left: 10px;
          }
        }
      }

      ul.consultants-items {
        padding-bottom: 20px;
        list-style: none;
        height: 500px;
        overflow-y: auto;
        padding-left: 0px;
        height: 320px;

        .consultants-starter {
          margin-bottom: 6px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0px 20px;

          h4 {
            font-size: 14px;
            font-weight: 800;
          }

          .consultants-item-header {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            align-items: center;
            padding: 16px 0px;

            label {
              color: #000000;
              font-size: 14px;
            }

            .select-checkbox {
              height: 15px;
              margin-right: 10px;
              margin-top: -1px;
            }
          }

          p {
            color: #131313;
          }
        }

        .consultants-item {
          background: #f5f5f5 0% 0% no-repeat padding-box;
          margin-bottom: 10px;
          border-bottom: 1px solid rgb(221, 221, 221);
          padding: 0px 20px;

          .consultants-item-header {
            display: grid;
            padding: 0px 4px;
            grid-template-columns: 60px calc(98% - 60px);
            grid-column-gap: 20px;

            .consultants-item-brand {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 60px;
              height: 60px;
              padding-top: 10px;
              padding-bottom: 10px;

              .select-checkbox {
                margin-right: 10px;
              }

              img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                object-fit: cover;
              }
            }

            .content {
              display: flex;
              width: 100%;
              align-items: center;
              padding-right: 15px;
              justify-content: space-between;

              .title-row {
                width: calc(100% - 200px);

                label {
                  display: block;
                  font-size: 14px;

                  margin-bottom: 1px;
                  font-weight: 800;
                }

                span {
                  color: #808080;
                  font-size: 13px;
                  margin-bottom: 6px;
                }
              }

              .option {}
            }
          }
        }
      }

      .empty-widget {
        background: #f6f6f6;
        padding: 20px;

        .empty-widget-body {
          height: 350px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          padding: 0px;

          p {
            text-align: center;
          }

          .add-btn {
            width: 180px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
            margin-right: 20px;
            display: center;
            justify-content: center;
          }
        }
      }

      .options {
        display: flex;
        align-items: center;
        padding: 20px 30px;
        height: 70px;

        .assign-btn {
          height: 45px;
          width: 100px;
          background: #1885ad 0% 0% no-repeat padding-box;
          border-radius: 5px;
          opacity: 1;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0px 20px;
          margin-right: 20px;
        }

        .close-btn {
          width: 40px;
          height: 45px;
          background: transparent;
          border-radius: 5px;
          opacity: 1;
          color: #1885ad;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .member-management {
    margin: 0 auto;
    width: 600px;

    .member-container {
      background: #fff;
      padding: 30px 50px;
      border-radius: 5px;

      .member-header {
        width: 100%;
        padding-bottom: 30px;

        h3 {
          text-align: center;
        }
      }

      .member-search-widget {
        display: flex;
        align-items: center;
        grid-column-gap: 30px;
        padding-bottom: 30px;
        position: relative;

        .search-container {
          border: 1px solid #ccc;
          height: 45px;
          width: 100%;
          display: flex;
          align-items: center;
          padding: 0px 10px;
          border-radius: 5px;

          img {
            width: 25px;
            height: 25px;
          }

          input {
            height: 43px;
            width: 100%;
            padding-left: 15px;
            outline: none;
          }
        }

        .search_dropdown__body {
          position: absolute;
          top: 45px;
          width: 48%;
          background: #fff;
          z-index: 999;
          box-shadow: 0px 4px 7px #ccc;
          height: 250px;
          overflow-y: auto;
          border-radius: 5px;

          .dropdown__item {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #e8e8e8;
            padding: 20px 10px;
            cursor: pointer;

            &:hover {
              background: #e8e8e8;
            }

            img {
              height: 30px;
              width: 30px;
              object-fit: cover;
              margin-right: 15px;
              border-radius: 50%;
            }

            .text {
              span {
                font-size: 15px;
              }
            }
          }
        }

        .invite-option {
          display: flex;
          align-items: center;
          justify-content: space-between;

          span {
            color: #b3b3b3;
            text-align: center;
          }

          .invite-btn {
            width: 127px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
          }
        }
      }

      .member-body {
        .member-body-title {
          font-size: 12px;
          color: #031019;
        }

        .member-fieldset {
          border: 1px solid #c2c2c2;
          border-radius: 5px;
          padding: 15px;

          .collaboraters-widget {
            padding: 10px 0px;
            display: flex;
            flex-wrap: wrap;

            .item {
              background: #1ba5a4 0% 0% no-repeat padding-box;
              border-radius: 20px;
              display: flex;
              align-items: center;
              padding: 4px 4px;
              margin-right: 8px;
              margin-bottom: 8px;
              position: relative;

              .profile-img {
                width: 26px;
                height: 26px;
                border-radius: 50%;
                margin-right: 5px;
              }

              .name {
                color: #fff;
                margin-right: 10px;
              }

              .remove-member-btn {
                background: crimson;
                border-radius: 50%;
                height: 20px;
                width: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: -11px;
                right: -7px;
              }
            }
          }
        }

        .sectected-member-count {
          font-size: 14px;
          color: #6e6e6e;
          margin-top: 10px;
          display: block;
        }
      }

      .member-managment-option {
        padding-top: 20px;
        display: flex;
        justify-content: flex-start;

        .btn-save {
          width: 100px;
          height: 45px;
          background: #1890a9 0% 0% no-repeat padding-box;
          border-radius: 4px;
          color: #fff;
          outline: none;
          margin-right: 20px;
          display: center;
          justify-content: center;
        }

        .btn-back {
          height: 45px;
          border-radius: 4px;
          color: #1890a9;
          outline: none;
        }
      }
    }
  }
}

.input-flex {
  display: flex;
}
</style>